module.exports = __webpack_public_path__ + "static/media/marker-red.469c4d3e.png";